__webpack_require__.p = "/vinnegpt/";